import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'toast',
  templateUrl: 'toast.component.html',
  styleUrls: ['toast.component.css']
})
export class ToastComponent {

  message!: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any)
  {
    this.message = data;
  }
}